module.exports = __webpack_public_path__ + "app-static/img/hand.769376ad.gif";